export default __webpack_public_path__ + "static/media/lynnGameplay.1fabef06.png";